// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar{
    display: flex;
    justify-content: space-around;
    padding: 16px;
    box-shadow: 0 1px 3px -2px black;
    align-items: center;
}
.nav-logo{
    display: flex;
    align-items: center;
    gap: 10px;
}
.nav-logo{
    color: #171717;
    font-size: 38px;
    font-weight: 600;

}
.nav-menu{
    display: flex;
    align-items: center;
    list-style: none;
    gap: 50px;
    color: #626262;
    font-size: 20px;
    font-weight: 500;
}
.nav-menu li{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    cursor: pointer;
}
.nav-menu hr{
    border: none;
    width: 80%;
    height: 3px;
    border-radius: 10px;
    background: #FF4141;
}
.nav-login-cart{
    display: flex;
    align-items: center;
    gap: 45px;
}

.nav-login-cart button{
    width: 157px;
    height: 58px;
    outline: none;
    border: 1px solid #7a7a7a;
    border-radius: 75px;
    color: #515151;
    font-size: 20px;
    font-weight: 500;
    background: white;
    cursor: pointer;

}
.nav-login-cart button:active{
    background: #f3f3f3;
}
.nav-cart-count{
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -35px;
    margin-left: -55px;
    border-radius: 11px;
    font-size: 14px;
    background: red;
    color: white;
}

.nav-dropdown{
    display: none;
}
@media(max-width:1280px){
    .navbar{
        padding: 12px 50px;
    }
    .nav-logo img{
        width: 40px;

    }
    .nav-logo p{
        font-size: 25px;
    }
    .nav-menu{
        gap: 30px;
        font-size: 16px;
    }
    .nav-login-cart{
        gap: 30px;

    }
    .nav-login-cart button{
        width: 120px;
        height: 45px;
        font-size: 16px;
    }
    .nav-cart-count{
        margin-left: -40px;
        font-size: 12px;
    }
}
@media(max-width:1024px)
{
    .navbar{
        padding: 12px 30px;
    }
    .nav-menu{
        gap: 25px;
        font-size: 14px;
    }
    .nav-login-cart button{
        width: 80px;
        height: 35px;
        font-size: 14px;
    }
    .nav-login-cart img{
        width: 30px;
    }
    .nav-cart-count{
        width: 18px;
        height: 18px;
    }
}
@media(max-width:800px) {
    .navbar{
        padding: 10px 0px;

    }
    .nav-dropdown{
        display: block;
        width: 30px;
        rotate: -90deg;
        transition: 0.5s;
    }
    .nav-menu{
        display: none;
        height: 80px;
        width: 100%;
        position: absolute;
        background-color: white;
        justify-content: center;
        top: 50px;
    }
    .nav-menu-visible{
        display: flex;
    }
    .nav-dropdown.open{
        transform: rotate( 90deg);
    }
}
@media(max-width:500px){
    .navbar{
        width: 8px 0px;
        gap: 0;
    }
    .nav-logo{
        transform: scale(0.8);
    }
    .nav-menu{
        height: 70px;
        top: 50px;

    }
    .nav-login-cart{
        transform: scale(0.8);
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;;AAEnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;;IAEf;IACA;QACI,eAAe;IACnB;IACA;QACI,SAAS;QACT,eAAe;IACnB;IACA;QACI,SAAS;;IAEb;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;AACA;;IAEI;QACI,kBAAkB;IACtB;IACA;QACI,SAAS;QACT,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;AACA;IACI;QACI,iBAAiB;;IAErB;IACA;QACI,cAAc;QACd,WAAW;QACX,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,uBAAuB;QACvB,uBAAuB;QACvB,SAAS;IACb;IACA;QACI,aAAa;IACjB;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI;QACI,cAAc;QACd,MAAM;IACV;IACA;QACI,qBAAqB;IACzB;IACA;QACI,YAAY;QACZ,SAAS;;IAEb;IACA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".navbar{\n    display: flex;\n    justify-content: space-around;\n    padding: 16px;\n    box-shadow: 0 1px 3px -2px black;\n    align-items: center;\n}\n.nav-logo{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.nav-logo{\n    color: #171717;\n    font-size: 38px;\n    font-weight: 600;\n\n}\n.nav-menu{\n    display: flex;\n    align-items: center;\n    list-style: none;\n    gap: 50px;\n    color: #626262;\n    font-size: 20px;\n    font-weight: 500;\n}\n.nav-menu li{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 3px;\n    cursor: pointer;\n}\n.nav-menu hr{\n    border: none;\n    width: 80%;\n    height: 3px;\n    border-radius: 10px;\n    background: #FF4141;\n}\n.nav-login-cart{\n    display: flex;\n    align-items: center;\n    gap: 45px;\n}\n\n.nav-login-cart button{\n    width: 157px;\n    height: 58px;\n    outline: none;\n    border: 1px solid #7a7a7a;\n    border-radius: 75px;\n    color: #515151;\n    font-size: 20px;\n    font-weight: 500;\n    background: white;\n    cursor: pointer;\n\n}\n.nav-login-cart button:active{\n    background: #f3f3f3;\n}\n.nav-cart-count{\n    width: 22px;\n    height: 22px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: -35px;\n    margin-left: -55px;\n    border-radius: 11px;\n    font-size: 14px;\n    background: red;\n    color: white;\n}\n\n.nav-dropdown{\n    display: none;\n}\n@media(max-width:1280px){\n    .navbar{\n        padding: 12px 50px;\n    }\n    .nav-logo img{\n        width: 40px;\n\n    }\n    .nav-logo p{\n        font-size: 25px;\n    }\n    .nav-menu{\n        gap: 30px;\n        font-size: 16px;\n    }\n    .nav-login-cart{\n        gap: 30px;\n\n    }\n    .nav-login-cart button{\n        width: 120px;\n        height: 45px;\n        font-size: 16px;\n    }\n    .nav-cart-count{\n        margin-left: -40px;\n        font-size: 12px;\n    }\n}\n@media(max-width:1024px)\n{\n    .navbar{\n        padding: 12px 30px;\n    }\n    .nav-menu{\n        gap: 25px;\n        font-size: 14px;\n    }\n    .nav-login-cart button{\n        width: 80px;\n        height: 35px;\n        font-size: 14px;\n    }\n    .nav-login-cart img{\n        width: 30px;\n    }\n    .nav-cart-count{\n        width: 18px;\n        height: 18px;\n    }\n}\n@media(max-width:800px) {\n    .navbar{\n        padding: 10px 0px;\n\n    }\n    .nav-dropdown{\n        display: block;\n        width: 30px;\n        rotate: -90deg;\n        transition: 0.5s;\n    }\n    .nav-menu{\n        display: none;\n        height: 80px;\n        width: 100%;\n        position: absolute;\n        background-color: white;\n        justify-content: center;\n        top: 50px;\n    }\n    .nav-menu-visible{\n        display: flex;\n    }\n    .nav-dropdown.open{\n        transform: rotate( 90deg);\n    }\n}\n@media(max-width:500px){\n    .navbar{\n        width: 8px 0px;\n        gap: 0;\n    }\n    .nav-logo{\n        transform: scale(0.8);\n    }\n    .nav-menu{\n        height: 70px;\n        top: 50px;\n\n    }\n    .nav-login-cart{\n        transform: scale(0.8);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
